export default __webpack_public_path__ + "static/cover-a1014bfce9c73fa80fb6be487b3b683f.png";